import script from "./pedicheck.vue?vue&type=script&setup=true&lang=js"
export * from "./pedicheck.vue?vue&type=script&setup=true&lang=js"

import "./pedicheck.vue?vue&type=style&index=0&id=661a6ed3&scoped=true&lang=css"

import exportComponent from "/Users/mac/Documents/GitHub/cristhianVeAl_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-661a6ed3"]])

export default __exports__